import { render, staticRenderFns } from "./VulnerabilityView.vue?vue&type=template&id=eb9da34e&"
import script from "./VulnerabilityView.vue?vue&type=script&lang=js&"
export * from "./VulnerabilityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports